import TextAreaCharacter from "./TextAreaCharacter";

export default TextAreaCharacter;
